import { Injectable } from "@angular/core";
import { BaseNotifier } from "../../../shared/notifiers/base-notifier";
import { Ref } from "../../../shared/providers/ref";
import { MenuRepositoryProvider } from "../../../shared/providers/repository-providers";
import { GeoportalViewState } from "./geoportal-view-state";

/**
 * GeoportalViewNotifier — dueño del estado del geoportal de presentación.
 *
 * Carga el catálogo de aplicaciones desde IMenuRepository (domain) vía su
 * implementación de infrastructure, resuelta con MenuRepositoryProvider —
 * la presentación NUNCA hardcodea la lista de apps. La navegación es nativa
 * del <a> de cada card (href + target), sin método de navegación aquí.
 */
@Injectable()
export class GeoportalViewNotifier extends BaseNotifier<GeoportalViewState> {
  private static readonly INITIAL: GeoportalViewState = {
    loading: true,
    applications: [],
    error: null,
  };

  constructor(ref: Ref) {
    super(ref, GeoportalViewNotifier.INITIAL);
  }

  override build(): void {
    this.setState(GeoportalViewNotifier.INITIAL);

    this.ref
      .watch(MenuRepositoryProvider)
      .instance.getApplications()
      .then((res) => {
        if (res.success && res.data) {
          this.updateState((s) => ({
            ...s,
            loading: false,
            applications: res.data!,
          }));
        } else {
          this.updateState((s) => ({
            ...s,
            loading: false,
            error: "No se pudo cargar el catálogo de aplicaciones",
          }));
        }
      })
      .catch((err) => {
        console.error("[GEOPORTAL] Error cargando aplicaciones:", err);
        this.updateState((s) => ({
          ...s,
          loading: false,
          error: "No se pudo cargar el catálogo de aplicaciones",
        }));
      });
  }
}


